"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

function diffFromNow(date, format, timeUnit) {
  var now = moment_1.default();
  var comparator = moment_1.default(date, format);
  if (!comparator.isValid()) return -1;
  return now.diff(date, timeUnit, true);
}

exports.diffFromNow = diffFromNow;